import { render, staticRenderFns } from "./CarouselSettings.vue?vue&type=template&id=93cae2d8"
import script from "./CarouselSettings.vue?vue&type=script&lang=js"
export * from "./CarouselSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports